module.exports = __webpack_public_path__ + "img/tb1041-12-1974.prt.5b46cc1a.jpg";